/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_organizationActivityLog_requestListOrganizationActivityLog } from '../models/api_organizationActivityLog_requestListOrganizationActivityLog';
import type { api_organizationActivityLog_responseListOrganizationActivityLog } from '../models/api_organizationActivityLog_responseListOrganizationActivityLog';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OrganizationActivityLogService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List OrganizationActivityLog
     * アクティビティログ一覧を取得する。
     * @returns api_organizationActivityLog_responseListOrganizationActivityLog responseListOrganizationActivityLog
     * @throws ApiError
     */
    public postOrganizationActivityLogList({
        body,
    }: {
        /**
         * requestListOrganizationActivityLog
         */
        body: api_organizationActivityLog_requestListOrganizationActivityLog,
    }): CancelablePromise<api_organizationActivityLog_responseListOrganizationActivityLog> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization_activity_log/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
